<ng-container [formGroup]="form">
  <div class="form-group">
    <label for="streetAddress" class="required">Street Address</label>
    <input pInputText id="streetAddress" formControlName="streetAddress" />
    <error-block [field]="form.controls.streetAddress" [messages]="{
      required: 'Street Address is required.'
    }"></error-block>
  </div>

  <div class="form-group">
    <label for="location" class="required">City/State/Postal Code</label>
    <location-search inputId="location" formControlName="location"></location-search>
    <error-block [field]="form.controls.location" [messages]="{
      required: 'City/State/Postal Code is required.'
    }"></error-block>
  </div>

  <div class="form-group">
    <label class="required">Normalized Address</label>
    <div *ngIf="loadingNormalization" class="normalized-address-loading" aria-live="polite">
      <span class="pi pi-spin pi-spinner" aria-hidden="true"></span> Loading suggestions...
    </div>
    <fieldset *ngIf="!loadingNormalization && normalizedAddresses.length > 0" class="radio-option-list">
      <legend class="p-sr-only">Select a normalized address</legend>
      <div
        *ngFor="let address of normalizedAddresses; index as i"
        class="radio-option-item"
        role="button"
        (click)="selectAddress(address)"
      >
        <p-radioButton
          name="selectedNormalizedAddress"
          [value]="address"
          formControlName="selectedNormalizedAddress"
          [inputId]="'normalizedAddress' + i">
        </p-radioButton>
        <label [for]="'normalizedAddress' + i">
          <span *ngIf="address.isParsedFromQuery">Use as entered: </span>
          {{ address.address1 }}, {{ address.city }}, {{ address.state }} {{ address.postalCode }}
        </label>
      </div>
    </fieldset>
    <div *ngIf="!loadingNormalization && !searchCompleted" class="normalization-hint">
      Enter a valid address to see suggestions.
    </div>
    <div *ngIf="!loadingNormalization && searchError" class="normalization-error" role="alert">
      <span class="pi pi-exclamation-triangle" aria-hidden="true"></span> Failed to normalize address. Please try again.
    </div>
  </div>
</ng-container>
